const config = {
  apiBaseUrl: "https://api.plaay.nl",
};

if(window.location.href.startsWith("http://localhost:3000/")) {
  config.apiBaseUrl = "http://localhost:3001";
}

export default config;
